import { REGISTRATION_SECTION_KEYS } from './registration.constants';
import { LEAD_EVENT_STAGES } from '../../constants/leadEventStages';

export const REGISTRATION_SECTION_STAGES = Object.freeze({
  [REGISTRATION_SECTION_KEYS.PERSONAL_INFO]: LEAD_EVENT_STAGES.PERSONAL_DETAILS,
  [REGISTRATION_SECTION_KEYS.VEHICLE_INFO]: LEAD_EVENT_STAGES.VEHICLE_INFO,
  [REGISTRATION_SECTION_KEYS.DRIVERS_LICENSE]:
    LEAD_EVENT_STAGES.DRIVER_LICENSE_UPLOAD,
});

export function completedSectionIdsFromEvents(events = []) {
  const stages = new Set((events || []).map((e) => e.stage));
  const ids = [];
  if (stages.has(LEAD_EVENT_STAGES.PERSONAL_DETAILS))
    ids.push(REGISTRATION_SECTION_KEYS.PERSONAL_INFO);
  if (stages.has(LEAD_EVENT_STAGES.VEHICLE_INFO))
    ids.push(REGISTRATION_SECTION_KEYS.VEHICLE_INFO);
  if (stages.has(LEAD_EVENT_STAGES.DRIVER_LICENSE_UPLOAD))
    ids.push(REGISTRATION_SECTION_KEYS.DRIVERS_LICENSE);
  return ids;
}

export function isRegistrationSectionCompleted(sectionKey, events = []) {
  const stage = REGISTRATION_SECTION_STAGES[sectionKey];
  if (!stage) return false;
  return (events || []).some((e) => e.stage === stage);
}

export function canAccessRegistrationSection(sectionKey, events = []) {
  if (isRegistrationSectionCompleted(sectionKey, events)) return false;
  const stages = new Set((events || []).map((e) => e.stage));
  if (sectionKey === REGISTRATION_SECTION_KEYS.PERSONAL_INFO) return true;
  if (sectionKey === REGISTRATION_SECTION_KEYS.VEHICLE_INFO)
    return stages.has(LEAD_EVENT_STAGES.PERSONAL_DETAILS);
  if (sectionKey === REGISTRATION_SECTION_KEYS.DRIVERS_LICENSE)
    return stages.has(LEAD_EVENT_STAGES.VEHICLE_INFO);
  return false;
}
